const CUSTOM_TABLE_TITLE_HEIGHT = 32;
export default CUSTOM_TABLE_TITLE_HEIGHT;
